import * as rewardConst from "./constants";
import { makeCall } from "@/utils/request";
import { buildOptions, getEndPoints } from "@/utils/api-call";

export const state = {
  historyProfile: [],
  historyEmployee: [],
  historyProfilePagination: {},
  historyEmployeePagination: {}
};

export const getters = {
  [rewardConst.GETTER_LIST_HISTORY_EMPLOYEE]: state => {
    return state.historyEmployee;
  },
  [rewardConst.GETTER_LIST_HISTORY_EMPLOYEE_PAGINATION]: state => {
    return state.historyEmployeePagination;
  },
  [rewardConst.GETTER_LIST_HISTORY_PROFILE]: state => {
    return state.historyProfile;
  },
  [rewardConst.GETTER_LIST_HISTORY_PROFILE_PAGINATION]: state => {
    return state.historyProfilePagination;
  }
};

export const actions = {
  [rewardConst.ACTION_GET_LIST_HISTORY_EMPLOYEE]: ({ commit }, options) => {
    if (options && options.employeeId) {
      const url = getEndPoints().employees.getEmployeeAccountHistory.replace(
        ":id",
        options.employeeId
      );
      makeCall(url, buildOptions("GET", options.params), commit).then(
        response => {
          if (response.data) {
            commit(rewardConst.MUTATION_SET_LIST_HISTORY_EMPLOYEE, response);
          }
        }
      );
    }
  },
  [rewardConst.ACTION_HISTORY_REVERT_EMPLOYEE]: ({ commit }, options) => {
    if (options && options.employeeId && options.historyId) {
      const url = getEndPoints()
        .employees.revertEmployeeChange.replace(":id", options.employeeId)
        .replace(":history_id", options.historyId);
      makeCall(url, buildOptions("PUT", options.params), commit).then(
        response => {
          if (response.error) {
            options.onRevertFailedHandler(response.error);
          } else if (options.onRevertFinishedHandler) {
            options.onRevertFinishedHandler(false, "Reverted Success");
          }
        },
        error => {
          console.log("error =", error);
          options.onRevertFailedHandler(error);
        }
      );
    }
  },
  [rewardConst.ACTION_HISTORY_REVERT_PROFILE]: ({ commit }, options) => {
    if (options && options.employeeId && options.historyId) {
      const url = getEndPoints()
        .employees.revertEmployeeProfileChange.replace(":id", options.employeeId)
        .replace(":history_id", options.historyId);
      makeCall(url, buildOptions("PUT", options.params), commit).then(
        response => {
          if (response.error) {
            options.onRevertFailedHandler(response.error);
          } else if (options.onRevertFinishedHandler) {
            options.onRevertFinishedHandler(false, "Reverted Success");
          }
        },
        error => {
          console.log("error =", error);
          options.onRevertFailedHandler(error);
        }
      );
    }
  }
};

export const mutations = {
  [rewardConst.MUTATION_SET_LIST_HISTORY_EMPLOYEE]: (
    state,
    historyEmployee
  ) => {
    state.historyEmployee = historyEmployee.data;
    state.historyEmployeePagination =
      historyEmployee.meta && historyEmployee.meta.pagination
        ? {
            ...{
              count: historyEmployee.meta.pagination.count,
              total: parseInt(historyEmployee.meta.pagination.total),
              itemsPerPage: historyEmployee.meta.pagination.per_page,
              totalPage: historyEmployee.meta.pagination.total_pages,
              current_page: parseInt(
                historyEmployee.meta.pagination.current_page
              )
            }
          }
        : state.historyEmployeePagination;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/history/index.js